// import React from "react";

// import css
import "./HappyerpFeature.scss";

const HappyerpFeature = () => {
  return (
    <section
      className="happyerp-feature_sect happyerp-sect_padding"
      style={{
        backgroundImage: "url('/assets/img/happyerp/home/features_bg.jpg')",
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <h6 className="happyerp-small_title_with_line">
              Happy ERP FEATURES
            </h6>
            <h2 className="happyerp-df45 happyerp-text_white happyerp-semibold">
              Keep Up The Sales Remote Features
            </h2>
            <p className="happyerp-df15 happyerp-text_white happyerp-regular happyerp-lh26">
              Team ipsum dolor sit ametconsecteturing elit sed do eiusmod tempor
              incididunt laboret dolore magna aliqua minaquaerat.
            </p>
            <ul class="happyerp-list">
              <li>
                <span class="material-symbols-outlined">arrow_forward</span>
                Enterprise-class applications
              </li>
              <li>
                <span class="material-symbols-outlined">arrow_forward</span>
                Leading ERP vendors
              </li>
              <li>
                <span class="material-symbols-outlined">arrow_forward</span>
                Relentless focus on re-invention
              </li>
            </ul>
          </div>
          <div className="col-lg-6">
            <div
              className="row"
              style={{
                rowGap: "30px",
                justifyContent: "center",
              }}
            >
              <div className="col-lg-6">
                <div className="happyerp-feature_single">
                  <div className="happyerp-icon">
                    <img src="/assets/img/happyerp/icon/shopping.png" alt="" />
                  </div>
                  <h3>conduct sales meetings</h3>
                  <p>
                    Meeting ipsum dolor sit amseteturing elit sed do eiusmod
                    tempor incididunt
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="happyerp-feature_single">
                  <div className="happyerp-icon">
                    <img src="/assets/img/happyerp/icon/feature2.png" alt="" />
                  </div>
                  <h3>conduct sales meetings</h3>
                  <p>
                    Meeting ipsum dolor sit amseteturing elit sed do eiusmod
                    tempor incididunt
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="happyerp-feature_single">
                  <div className="happyerp-icon">
                    <img src="/assets/img/happyerp/icon/feature3.png" alt="" />
                  </div>
                  <h3>conduct sales meetings</h3>
                  <p>
                    Meeting ipsum dolor sit amseteturing elit sed do eiusmod
                    tempor incididunt
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HappyerpFeature;
